import { styled } from 'styled-components'
import { NavBar } from 'antd-mobile'

import { getDesignToken } from 'src/styles/theme'

export const StyledHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: ${getDesignToken().colorBgContainer};
  border-bottom: 1px solid ${getDesignToken().colorBorderSecondary};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: block;
  padding-top: constant(safe-area-inset-top); /* iOS < 11.2 */
  padding-top: env(safe-area-inset-top); /* iOS >= 11.2 */

  @media (min-width: 901px) {
    display: none;
  }
`

export const StyledNavBar = styled(NavBar)`
  --height: 56px;
  --border-bottom: 1px solid ${getDesignToken().colorBorderSecondary};
  position: relative;
  display: flex;
  align-items: center;

  .adm-nav-bar-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: ${getDesignToken().colorTextBase};
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-width: calc(100% - 120px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    pointer-events: none;
  }

  .adm-nav-bar-left {
    padding: 0 8px;
    flex: 0 0 auto;
    min-width: 56px;
    z-index: 1;
    order: 1;
  }

  .adm-nav-bar-right {
    padding: 0 8px;
    flex: 0 0 auto;
    min-width: 56px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 1;
    order: 3;
    margin-left: auto;
  }
`
